import { c as _c } from "react/compiler-runtime";
import { useSearchParams } from 'next/navigation';
export default function useFeaturedActivities(t0) {
  const $ = _c(5);
  const user = t0 === undefined ? null : t0;
  const searchParams = useSearchParams();
  let t1;
  if ($[0] !== searchParams || $[1] !== user?.featuredActivities) {
    t1 = searchParams?.get("featuredId") || user?.featuredActivities;
    $[0] = searchParams;
    $[1] = user?.featuredActivities;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const featuredId = t1;
  if (!featuredId) {
    return null;
  }
  let t2;
  if ($[3] !== featuredId) {
    t2 = Array.isArray(featuredId) ? featuredActivities.map(_temp) : featuredActivities.split(",").map(_temp2);
    $[3] = featuredId;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}
function _temp2(id_0) {
  return parseInt(id_0, 10);
}
function _temp(id) {
  return parseInt(id, 10);
}